export default {"src":"/_next/static/media/X.dd99b8bc.svg","height":18,"width":18};